const SocialIconDebank = () => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.25 11.2204C14.25 13.54 12.3515 15.4204 10.0096 15.4204H2V12.6204H10.0096C10.7902 12.6204 11.4231 11.9936 11.4231 11.2204C11.4231 10.4472 10.7902 9.82041 10.0096 9.82041H7.18269V7.02041H10.0096C10.7902 7.02041 11.4231 6.39361 11.4231 5.62041C11.4231 4.84721 10.7902 4.22041 10.0096 4.22041H2V1.42041H10.0096C12.3515 1.42041 14.25 3.30081 14.25 5.62041C14.25 6.69611 13.8417 7.67735 13.1703 8.42041C13.8417 9.16347 14.25 10.1447 14.25 11.2204Z"
        fill="currentColor"
      />
      <path
        d="M2 1.42041C5.86599 1.42041 9 4.55442 9 8.42041C9 12.2864 5.86599 15.4204 2 15.4204V12.6204C4.3196 12.6204 6.2 10.74 6.2 8.42041C6.2 6.10081 4.3196 4.22041 2 4.22041V1.42041Z"
        fill="currentColor"
      />
    </svg>
  );
};

export { SocialIconDebank };
